import React, { useEffect, useState } from "react"
import styles from "./styles.module.scss"
import classNames from "classnames"

interface Props {
	className?: string
	currentPeriod: string;
	onChangeChecked: Function
}

export const TableCheckbox: React.FC<Props> = props => {
	const [isChecked, setIsChecked] = useState<boolean>(false)

	const onChange = (checked: boolean) => {
		setIsChecked(checked)

		props.onChangeChecked(checked)
	}

	useEffect(() => {
		onChange(false)
	}, [props.currentPeriod])

	return (
		<label className={classNames(styles.tableCheckbox, props.className)}>
			<input
				className={styles.tableCheckbox__input}
				type="checkbox"
				checked={isChecked}
				onChange={event => {
					onChange(event.target.checked)
				}}
			/>
			<span className={styles.tableCheckbox__field} />
		</label>
	)
}
